module.exports = "../../app/cells/pages/question/related_exams_v2_cell.rb";